// src/index.js
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

const app = (
  <HelmetProvider>
    <BrowserRouter basename="/templates/landscaping">
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (container.hasChildNodes()) {
  // HTML exists (from react-snap) → hydrate to keep SEO markup
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

reportWebVitals();
